import React from "react";
import image_link from "../assets/images/renovation.png";

const RenovationView = (props) => {
    return(
        <>
            <img className="photo_exemple" alt ="" src={image_link}/>
            <div className="title-container services-title">
                <div className="title">
                    <div className="title-fade"></div>
                    <div className="title-outline"></div>
                    <h1>Rénovation</h1>
                </div>
                <div className="title-gradient"></div>
            </div>
            <div className="content">
                <p>
                    La <strong><b>rénovation</b></strong> fait partie des spécialités de <strong><b>BIGORD PLOMBERIE SERVICES</b></strong>. Que ce soit pour <strong>moderniser des installations anciennes</strong> ou pour <strong>adapter votre système de plomberie et de chauffage</strong> à de nouveaux besoins, Olivier Bigord met son expertise au service de vos projets de rénovation. Il travaille en étroite collaboration avec ses clients pour trouver des solutions adaptées, efficaces et esthétiques, en garantissant une réalisation dans les règles de l'art.
                </p>
            </div>
        </>
    );
};

export default RenovationView;